import { CLOSE_TAKE_SNAPSHOT_MODAL, SHOW_TAKE_SNAPSHOT_MODAL } from './types';

export const showTakeSnapshotModal = () => ({
  type: SHOW_TAKE_SNAPSHOT_MODAL,
});

export const closeTakeSnapshotModal = () => ({
  type: CLOSE_TAKE_SNAPSHOT_MODAL,
});
